<tmx-nav-dropdown [dropdownTooltip]="'Apps'" [ariaLabel]="'apps'">
  <div class="position-relative webtools-body" container="body">
    <h6 *ngIf="hasLicensedItems$ | async" class="ms-2 mt-2">Licensed</h6>
    <ul *ngIf="hasLicensedItems$ | async" class="list-group list-group-flush">
      <ng-container *ngFor="let item of licensedItems$ | async">
        <li
          class="cursor-pointer list-group-item list-group-item-action border-0"
          (click)="contain($event); openSite(item); handleItemClick(item)"
        >
          <div class="d-flex text-decoration-none">
            <img
              [src]="item.imageSource"
              height="40"
              width="40"
              alt=""
              class="me-3"
            />
            <div class="card-caption">
              <h6 class="dropdown-header mb-0 p-0">{{ item.name }}</h6>
              <span>{{ item.description }}</span>
            </div>
          </div>
        </li>
        <div class="dropdown-divider"></div>
      </ng-container>
    </ul>

    <h6 *ngIf="hasUnlicensedItems$ | async" class="ms-2 mt-2">Unlicensed</h6>
    <ul *ngIf="hasUnlicensedItems$ | async" class="list-group list-group-flush">
      <ng-container *ngFor="let item of unlicensedItems$ | async">
        <li
          class="cursor-pointer list-group-item list-group-item-action border-0 flex-column align-items-start"
          (click)="
            contain($event); toggleLearnMore(item); handleItemClick(item)
          "
        >
          <div class="d-flex text-decoration-none">
            <img
              [src]="item.imageSource"
              height="40"
              width="40"
              alt=""
              class="me-3"
            />
            <div class="card-caption">
              <h6 class="dropdown-header mb-0 p-0">{{ item.name }}</h6>
              <span>{{ item.description }}</span>
            </div>
          </div>
          <div
            *ngIf="item.showLearnMore"
            class="w-100 d-flex align-items-center"
          >
            <small class="text-warning">
              You are not licensed for this app</small
            >
            <a
              class="btn btn-text-primary ms-auto"
              (click)="contain($event); openSite(item)"
            >
              Learn More</a
            >
          </div>
        </li>
        <div class="dropdown-divider"></div>
      </ng-container>
    </ul>

    <h6 *ngIf="hasExpiredItems$ | async" class="ms-2 mt-2">Expired</h6>
    <ul *ngIf="hasExpiredItems$ | async" class="list-group list-group-flush">
      <ng-container *ngFor="let item of expiredItems$ | async">
        <li
          class="cursor-pointer list-group-item list-group-item-action border-0 flex-column align-items-start"
          (click)="
            contain($event); toggleLearnMore(item); handleItemClick(item)
          "
        >
          <div class="d-flex text-decoration-none">
            <img
              [src]="item.imageSource"
              height="40"
              width="40"
              alt=""
              class="me-3"
            />
            <div class="card-caption">
              <h6 class="dropdown-header mb-0 p-0">{{ item.name }}</h6>
              <span>{{ item.description }}</span>
            </div>
          </div>
          <div
            *ngIf="!item.showLearnMore"
            class="w-100 d-flex align-items-center"
          >
            <a
              class="btn btn-text-primary ms-auto"
              (click)="contain($event); openSite(item)"
              >Learn More</a
            >
          </div>
        </li>
        <div class="dropdown-divider"></div>
      </ng-container>
    </ul>

    <div class="d-flex justify-content-between">
      @if (showLogout()) {
        <a class="btn btn-outline-danger" (click)="logout()">Logout</a>
      }
      @if (showChangePassword()) {
        <a class="btn btn-outline-secondary" (click)="changePassword()"
          >Change Password</a
        >
      }
    </div>
  </div>
  <i class="modus-icons notranslate apps-icon" aria-hidden="true" icon>apps</i>
</tmx-nav-dropdown>
